module.exports = __webpack_public_path__ + "img/marker-icon.2273e3d8.png";